import { Typography } from "@hellocarbo/lasagne";

import PasswordConstraints from "./PasswordConstraints";

const SignUp = () => {
  const isNewSignup =
    // Can't rely on the data from the feature context since it's not reliable for AB tests
    document.getElementById("new_signup_page")?.dataset.enabled === "true";

  if (!isNewSignup) {
    return <PasswordConstraints />;
  }

  return (
    <div className="gap-lg grid h-screen w-screen place-content-center justify-items-center">
      <Typography step="3" as="h1">
        La nouvelle page de sign_up arrive bientôt !
      </Typography>
      <img src="https://www.animatedimages.org/data/media/1664/animated-work-in-progress-image-0023.gif" />
    </div>
  );
};

export default SignUp;
